const BULK_UPDATE_CONFIG_NAMES = {
  EXTERNAL_AUDIT_CASE: "EXTERNAL_AUDIT_CASE",
};
const BULK_UPDATE_CONFIGURATIONS = {};
const externalAuditCaseFieldNames = {
  CASE_STATUS: "Case Status",
  CASE_FINAL_OUTCOME: "Case Final Outcome",
  MANUAL_REFUND_REQUIRED: "Manual Refund Required",
  REFUND_COMPLETED_DATE: "Refund Completed Date",
  REFUND_SUBMMITED_DATE: "Refund Submitted Date",
  ROUND_OUTCOME: "Round Outcome",
  CASE_ROUND_DETERMINATION_DATE: "Case Round Determination Date",
  CASE_ROUND_SUBMISSION_DATE: "Case Round Actual Submission Date",
  ADVANCE_TO_NEXT_ROUND: "Advance to next Round",
  DENIAL_REASON: "Denial Reason",
  TARGET_RATIONALE: "Target Rationale",
  CASE_PROCESS_MANAGER:"Case Process Manager"
};
export const BULK_UPDATE_WARNINGS = {
  REMANING_DOLLARS_IN_REVIEW: "remainingDollarsInReview"
}
BULK_UPDATE_CONFIGURATIONS[BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE] = [
  {
    displayName: externalAuditCaseFieldNames.CASE_STATUS,
    saveValuePropertyName: "statusId",
  },
  {
    displayName: externalAuditCaseFieldNames.CASE_FINAL_OUTCOME,
    saveValuePropertyName: "caseFinalOutcomeId",
  },
  {
    displayName: externalAuditCaseFieldNames.MANUAL_REFUND_REQUIRED,
    saveValuePropertyName: "manualRefundRequired",
  },
  {
    displayName: externalAuditCaseFieldNames.REFUND_COMPLETED_DATE,
    saveValuePropertyName: "refundCompletedDate",
  },
  {
    displayName: externalAuditCaseFieldNames.REFUND_SUBMMITED_DATE,
    saveValuePropertyName: "refundSubmittedDate",
  },
  {
    displayName: externalAuditCaseFieldNames.ROUND_OUTCOME,
    saveValuePropertyName: "roundOutcomeId",
  },
  {
    displayName: externalAuditCaseFieldNames.CASE_ROUND_DETERMINATION_DATE,
    saveValuePropertyName: "caseRoundDaterminationDate",
  },
  {
    displayName: externalAuditCaseFieldNames.CASE_ROUND_SUBMISSION_DATE,
    saveValuePropertyName: "caseRoundSubmissionDate",
  },
  {
    displayName: externalAuditCaseFieldNames.ADVANCE_TO_NEXT_ROUND,
    saveValuePropertyName: "advanceCaseToNextRound",
  },
  {
    displayName: externalAuditCaseFieldNames.DENIAL_REASON,
    saveValuePropertyName: "denialReasonCode",
  },
  {
    displayName: externalAuditCaseFieldNames.TARGET_RATIONALE,
    saveValuePropertyName: "caseTargetRationaleValue",
  },
  {
    displayName: externalAuditCaseFieldNames.CASE_PROCESS_MANAGER,
    saveValuePropertyName: "caseProcessManagerId",
  }
];
export {
  BULK_UPDATE_CONFIG_NAMES,
  BULK_UPDATE_CONFIGURATIONS,
  externalAuditCaseFieldNames,
};

export const getDisplayNameFromProperty = (propertyName): string => {
  const configItem = BULK_UPDATE_CONFIGURATIONS[
    BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE
  ].find((x) => x.saveValuePropertyName === propertyName);
  return configItem?.displayName;
};
